import React from 'react';
import { formatElementFromHtmlAst, MarkupElement } from 'src/functions/formatElement.htmlAst';
import { HighlightBackground, HighlightContent, HighlightText } from './caseStudies.highlight.styles';

interface CaseStudyHighlightProps {
  highlight: {
    childMarkdownRemark: {
      htmlAst: {
        type: string;
        children: MarkupElement[]
      }
    }
  }
}

const CaseStudyHighlight = ({ highlight }: CaseStudyHighlightProps): JSX.Element => {
  return (
    <HighlightContent>
      <HighlightText>
        {highlight.childMarkdownRemark.htmlAst.children.map((child, index) => formatElementFromHtmlAst(child, `${index}`))}
      </HighlightText>
      <HighlightBackground />
    </HighlightContent>
  )
}

export default CaseStudyHighlight;
